import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';

const tagName = 'div';

register('wm-gridrow', (): IBuildTaskDef => {
    return {
        pre: (attrs) => {
          return `<${tagName} wmLayoutGridRow wmsTransclude ${getAttrMarkup(attrs)}>`;
        },
        post: () => `</${tagName}>`
    };
});

export default () => {};
